import { Card, CardContent } from "@/components/ui/card";
import teamImage from "@/assets/team-collaboration.webp";

const AboutSectionEN = () => {
  return (
    <section id="about" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
              Our 
              <span className="text-primary"> Mission</span>
            </h2>
            <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
              We are a foundation dedicated exclusively to researching neurological diseases 
              such as Alzheimer's, Parkinson's, ALS and other conditions that affect the nervous system.
            </p>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              Our multidisciplinary team of scientists, doctors and researchers works 
              tirelessly to develop innovative treatments and improve the quality of life 
              of patients and their families.
            </p>
            
            <div className="grid grid-cols-2 gap-6">
              <Card className="shadow-soft border-0 bg-accent">
                <CardContent className="p-6 text-center">
                  <div className="text-3xl font-bold text-primary mb-2">25+</div>
                  <div className="text-sm text-muted-foreground">Years of research</div>
                </CardContent>
              </Card>
              <Card className="shadow-soft border-0 bg-accent">
                <CardContent className="p-6 text-center">
                  <div className="text-3xl font-bold text-secondary mb-2">150+</div>
                  <div className="text-sm text-muted-foreground">Active projects</div>
                </CardContent>
              </Card>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src={teamImage} 
              alt="Research team collaborating" 
              width={628}
              height={418}
              loading="lazy"
              decoding="async"
              className="rounded-2xl shadow-medium w-full h-auto"
            />
            <div className="absolute -top-4 -right-4 w-32 h-32 bg-gradient-primary rounded-full opacity-20"></div>
            <div className="absolute -bottom-4 -left-4 w-24 h-24 bg-gradient-secondary rounded-full opacity-30"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSectionEN;
